import PropTypes from 'prop-types';
import Guidelines from './Guidelines';
import css from './Guidelines.scss';

Guidelines.displayName = 'Guidelines';

const classes = {
	root: css.guidelines,
	columns: css.guidelinesColumns,
	column: css.guidelinesColumn,
	rows: css.guidelinesRows,
	row: css.guidelinesRow,
};

Guidelines.propTypes = {
	className: PropTypes.string,
	classes: PropTypes.objectOf(PropTypes.string),
	columns: PropTypes.number,
	rows: PropTypes.number,
	maxWidth: PropTypes.number,
	maxHeight: PropTypes.number,
};

Guidelines.defaultProps = {
	className: '',
	classes,
	columns: 12,
	rows: 0,
	maxWidth: undefined,
	maxHeight: undefined,
};

export { Guidelines };
export default Guidelines;
